import { TFavoriteEntityType } from '../../../types/favorites';
import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EToggleFavoritesEntityType } from './types';

export const toggleEntityType = actionGenerator<EToggleFavoritesEntityType.Toggle, TFavoriteEntityType>(
  EToggleFavoritesEntityType.Toggle,
);
